import {gql} from '@apollo/client'

export const GET_USERS = gql`
  query GetUsers($q: String, $page: Int, $limit: Int, $sortBy: String, $sortDirection: String) {
    users(q: $q, page: $page, limit: $limit, sortBy: $sortBy, sortDirection: $sortDirection) {
      collection {
        id
        firstName
        lastName
        fullName @client
        displayName @client
        email
        accounts {
          displayName @client
          name
          contactFirstName
          contactLastName
        }
        invitationSentAt
        accessRevokedAt
        lastSignInAt
      }
      metadata {
        totalCount
      }
    }
  }
`
